import Badge from '@components/Badge';
import styled from '@emotion/styled';
import { ItemRow } from '@models/item';

interface Props {
    item: ItemRow;
}

function Badges({ item }:Props) {
    const { badges } = item;
    return (
        <Container>
            {badges?.map((badge) => (
                <Badge key={badge}>{badge}</Badge>
            ))}
        </Container>
    );
}

const Container = styled.div`
    flex-wrap: wrap;
    gap: var(--spacing-2);
    display: flex;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    justify-content: center;
`;

export default Badges;
